import Vue from 'deps/vue';
import * as paths from '../190506-@shared/modules/paths';
import service from './service';

Vue.config.productionTip = false;

// 插件
Vue.use(Vue => {
  // 添加实例属性
  Vue.prototype.$service = service;
  Vue.prototype.$paths = paths;
});

export default Vue;
